<template>
  <div ref="spinner" v-if="toggle" class="fixed inset-0 z-top flex flex-col items-center justify-center bg-white">
    <div :class="`text-xl text-${color} py-10`">
      <img v-if="appConfig.layout.main_logo && !!getImage(appConfig, appConfig.layout.main_logo, 'original')" :src="getImage(appConfig, appConfig.layout.main_logo, 'original')" :alt="title" :class="'px-1 py-2 max-h-56 max-w-96 object-contain'"/>
      <span v-else>{{ title }}</span>
    </div>
    <div
      :class="`w-12 h-12 rounded-full border-4 border-t-transparent animate-spin bg-${color}`"
    ></div>
  </div>
</template>
<script>
// TODO gestire la grafica nuova con tailwind o gif

import { mapGetters } from 'vuex'
import Helpers from '@/components/Helpers'

export default {
  props: {
    toggle: {
      type: Boolean,
      required: true
    }
  },
  mixins: [
    Helpers
  ],
  computed: {
    ...mapGetters({
      appConfig: 'app/appConfig',
    }),
    color: function() {
      return `[${process.env.VUE_APP_PRIMARY_COLOR}]` || 'green'
    } 
  },
  data: () => ({
    title: process.env.VUE_APP_NAME || 'ReSole'
  }),
  watch: {
    toggle: function(val) {
      if (val) {
        this.toggle = true
        //UIkit.modal(this.$refs.spinner).show()
        //this.$refs.spinner.style.display="flex"
      } else {
        //UIkit.modal(this.$refs.spinner).hide()
        this.toggle = false
        //this.$refs.spinner.style.display="none"
      }
    }
  }
}
</script>
<style>
.loading-wrapper {
  width: 100%;
  height: 100%;
  position: fixed;
  align-items: center;
  left: 0;
  top: 0;
  background: rgba(255,255,255,0.7);
  z-index: 9999;
  display: none;
  justify-content: center;
}
</style>